import React, { useContext } from 'react';
import { HiOutlineArrowSmallLeft } from 'react-icons/hi2';
import { Link } from 'react-router-dom';
import { ProfileSliderContext } from '../../appContext';

function ProfileTopNavigation({ pageTitle }) {
  const {slider,setSlider} = useContext(ProfileSliderContext);
  const handelSlider = () => {
    setSlider(!slider);
  };
  return (
    <div className="inline-flex items-center">
      <Link to={'/profile'} onClick={handelSlider}>
        <div className="size-9 rounded-full active:bg-blue-50 inline-flex justify-center items-center lg:hidden">
          <HiOutlineArrowSmallLeft className="text-2xl text-coalBlack active:bg-sky-50" />
        </div>
      </Link>
      <h1 className="headingText capitalize">
        {pageTitle ? pageTitle : ''}
      </h1>
    </div>
  );
}

export default ProfileTopNavigation;
